import { validationMethods } from '../../../Utils/validationMethods';

const validation = {
  registrationNumber: validationMethods.requiredRegistrationNumber,
};

export default validation;
